import { getOffsetPercent, type CorridorExtent } from '../../../../utils/corridors';

import * as css from './ValueMarker.css';

const MARKER_WIDTH_PX = 4;
const MARKER_HALF_WIDTH_PX = MARKER_WIDTH_PX / 2;

type ValueMarkerProps = {
    value: number;
    extent: CorridorExtent;
    indicatorColor?: 'green' | 'yellow' | 'red' | 'white';
};

export const ValueMarker = ({ value, extent, indicatorColor = 'white' }: ValueMarkerProps) => (
    <div
        className={css.valueMarker}
        style={{
            left: `clamp(${MARKER_HALF_WIDTH_PX}px, ${getOffsetPercent(
                value,
                extent,
            )}%, calc(100% - ${MARKER_HALF_WIDTH_PX}px))`,
        }}
    >
        <div className={css.valueMarkerStem({ indicatorColor })} />
    </div>
);
